// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_u3-0";